/* eslint-disable global-require */
require("../categories-content/categories-content");
require("../portfolio-content/portfolio-content");

const STORAGE_KEY = "nm_services_content";
const DEFAULT_PLAQUE_IMAGE = require("../example-preview/img/example-01.jpeg");
/* eslint-enable global-require */

function categoriesStore() {
  return window.NMCategoriesContent;
}

function escapeHtml(value) {
  return categoriesStore().escapeHtml(value);
}

function createId() {
  return categoriesStore().createId();
}

function getServicePath(category) {
  return categoriesStore().getServicePath(category);
}

function normalizeService(item = {}, categoryKeys = []) {
  const name = String(item.name || "").trim();
  const image = String(item.image || "").trim();
  if (!name || !image) return null;

  const keys = Array.isArray(categoryKeys) && categoryKeys.length
    ? categoryKeys
    : categoriesStore().getCategoryKeys();
  let categoryKey = String(item.categoryKey || item.category || "").trim();
  if (!keys.includes(categoryKey)) {
    categoryKey = keys[0] || "";
  }
  if (!categoryKey) return null;

  return {
    id: String(item.id || createId()),
    name,
    description: String(item.description || "").trim(),
    image,
    categoryKey,
    showOnHome: item.showOnHome === true,
  };
}

function titleKey(value) {
  return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
}

function getDefaultServices() {
  const { outdoor, interior, museums } = categoriesStore().getCategoryMap();

  return [
    outdoor && {
      id: "p0",
      name: "Панель-кронштейн",
      description: "Благодаря многочисленным преимуществам панель-кронштейны занимают ведущие позиции среди объектов наружной рекламы.",
      image: DEFAULT_PLAQUE_IMAGE,
      categoryKey: outdoor.key,
      showOnHome: true,
    },
    interior && {
      id: "p1",
      name: "Интерьерная реклама",
      description: "Комплексные решения по интерьерной рекламе: навигация, таблички, лайтбоксы и POS-материалы.",
      image: DEFAULT_PLAQUE_IMAGE,
      categoryKey: interior.key,
      showOnHome: true,
    },
    museums && {
      id: "p2",
      name: "Информационные стенды",
      description: "Оформление экспозиций и информационных зон: стенды, навигация, пресс-волл и промо-конструкции.",
      image: DEFAULT_PLAQUE_IMAGE,
      categoryKey: museums.key,
      showOnHome: true,
    },
  ].filter(Boolean);
}

function extractServicesFromLegacyCategories(categories) {
  const known = categoriesStore().getCategories();
  const services = [];
  (categories || []).forEach((category) => {
    const matched = known.find((item) => (
      titleKey(item.title) === titleKey(category.title)
      || item.key === category.key
      || item.slug === category.slug
      || item.slug === category.key
    ));
    const categoryKey = matched?.key
      || String(category.key || category.slug || "").trim();
    const plaques = Array.isArray(category.plaques) ? category.plaques : [];
    const legacy = Array.isArray(category.services) ? category.services : [];
    [...plaques, ...legacy].forEach((entry) => {
      if (!entry?.name || !entry?.image) return;
      services.push({
        id: entry.id || createId(),
        name: entry.name,
        description: entry.description || "",
        image: entry.image,
        categoryKey,
        showOnHome: entry.showOnHome === true,
      });
    });
  });
  return services;
}

function normalizeData(raw) {
  const keys = categoriesStore().getCategoryKeys();
  if (!raw || typeof raw !== "object") {
    return { services: getDefaultServices() };
  }

  let incoming = [];
  if (Array.isArray(raw.services)) {
    incoming = raw.services;
  } else if (Array.isArray(raw.categories)) {
    incoming = extractServicesFromLegacyCategories(raw.categories);
  }

  const services = incoming
    .map((item) => normalizeService(item, keys))
    .filter(Boolean);

  return { services: services.length ? services : getDefaultServices() };
}

function getServicesData() {
  const cached = window.NMApi?.cache?.services;
  if (cached) return normalizeData(cached);
  return { services: getDefaultServices() };
}

function saveServicesData(data) {
  const normalized = normalizeData(data);
  if (window.NMApi) {
    window.NMApi.cache.services = normalized;
    window.NMApi.save("services", normalized).catch((error) => {
      window.alert(error.message || "Не удалось сохранить услуги"); // eslint-disable-line no-alert
    });
  }
  return normalized;
}

function getServices() {
  return getServicesData().services;
}

function getServicesByCategory(categoryKey) {
  return getServices().filter((item) => item.categoryKey === categoryKey);
}

function getHomeServices() {
  const items = [];
  const map = categoriesStore().getCategoryMap();
  getServices().forEach((service) => {
    if (!service.showOnHome) return;
    const category = map[service.categoryKey];
    if (!category) return;
    items.push({ service, category, plaque: service });
  });
  return items;
}

function getHomePlaques() {
  return getHomeServices();
}

function getCategories() {
  return categoriesStore().getCategories();
}

function getCategoryBySlug(slug, data) {
  return categoriesStore().getCategoryBySlug(slug, data);
}

function getCategoryFromLocation() {
  try {
    const section = categoriesStore().SERVICE_SECTION_SLUG || "izgotovlenie-reklamy";
    const current = window.location.pathname.match(
      new RegExp(`^/uslugi/${section}/([^/]+)/?$`),
    );
    if (current?.[1]) {
      const found = getCategoryBySlug(decodeURIComponent(current[1]));
      if (found) return found;
    }

    const legacyService = window.location.pathname.match(/^\/service\/([^/]+)\/?$/);
    if (legacyService?.[1]) {
      const found = getCategoryBySlug(decodeURIComponent(legacyService[1]));
      if (found) {
        window.history.replaceState({}, "", getServicePath(found));
        return found;
      }
    }

    const params = new URLSearchParams(window.location.search);
    const legacyKey = params.get("category");
    if (legacyKey) {
      const found = getCategoryBySlug(legacyKey);
      if (found) {
        window.history.replaceState({}, "", getServicePath(found));
        return found;
      }
    }
  } catch (error) {
    // ignore
  }
  return null;
}

function getNextCategory(category, data) {
  return categoriesStore().getNextCategory(category, data);
}

function categoryWithServices(category) {
  if (!category) return null;
  return {
    ...category,
    plaques: getServicesByCategory(category.key),
  };
}

function upsertService(service) {
  const data = getServicesData();
  const payload = normalizeService(service, categoriesStore().getCategoryKeys());
  if (!payload) return null;
  const index = data.services.findIndex((item) => item.id === payload.id);
  if (index >= 0) {
    data.services[index] = payload;
  } else {
    data.services.push(payload);
  }
  return saveServicesData(data);
}

function deleteService(id) {
  const data = getServicesData();
  data.services = data.services.filter((item) => item.id !== id);
  return saveServicesData(data);
}

function reassignServicesCategory(deletedKey, fallbackKey) {
  if (!deletedKey) return getServicesData();
  const data = getServicesData();
  data.services = data.services
    .map((item) => (
      item.categoryKey === deletedKey
        ? { ...item, categoryKey: fallbackKey || item.categoryKey }
        : item
    ))
    .filter((item) => item.categoryKey);
  return saveServicesData(data);
}

function renderPreviewCard(category, { asLink = true, withTags = true } = {}) {
  const href = getServicePath(category);
  const plaques = withTags ? getServicesByCategory(category.key) : [];
  const tags = plaques.map((item) => (
    `<li class="service-preview__tags-item">${escapeHtml(item.name)}</li>`
  )).join("");
  const image = categoriesStore().resolveCategoryImage(category);

  const inner = `
    <div class="service-preview__wrapper">
      <div class="service-preview__content">
        <div class="service-preview__img">
          <picture>
            <img src="${escapeHtml(image)}" alt="${escapeHtml(category.title)}" width="280" height="280">
          </picture>
        </div>
        <div class="service-preview__title h5">${category.titleHtml}</div>
      </div>
      ${tags ? `<div class="service-preview__tags"><ul class="service-preview__tags-list">${tags}</ul></div>` : ""}
    </div>
  `;

  if (!asLink) {
    return `<div class="service-preview">${inner}</div>`;
  }

  return `<a class="service-preview" href="${href}">${inner}</a>`;
}

function renderHomeExampleCard(plaque, category) {
  const href = getServicePath(category);
  const description = plaque.description
    ? `<p class="example-preview__desc p1">${escapeHtml(plaque.description)}</p>`
    : "";

  return `<a class="example-preview" href="${href}">
    <div class="example-preview__wrapper">
      <div class="example-preview__content">
        <div class="example-preview__title h5">${escapeHtml(plaque.name)}</div>
        ${description}
        <span class="example-preview__btn btn btn_arrow">
          <svg width="32" height="32" viewBox="0 0 32 32">
            <use xlink:href="#icon-arrow-right"></use>
          </svg>
        </span>
      </div>
      <div class="example-preview__img">
        <picture>
          <img src="${escapeHtml(plaque.image)}" alt="${escapeHtml(plaque.name)}" width="280" height="280">
        </picture>
      </div>
    </div>
  </a>`;
}

function hydrateServicesPage() {
  const list = document.querySelector("[data-services-list]");
  if (!list) return;

  const categories = getCategories();
  list.innerHTML = categories.map((category) => (
    `<li class="services__item">${renderPreviewCard(category, { asLink: true, withTags: false })}</li>`
  )).join("");
}

function updateExampleSwiper(wrapper) {
  const swiperRoot = wrapper.closest(".swiper");
  if (swiperRoot?.swiper) {
    swiperRoot.swiper.update();
    swiperRoot.swiper.slideTo(0, 0);
  }
}

function hydrateHomeServices() {
  const wrapper = document.querySelector("[data-services-home-slides]");
  if (!wrapper) return;

  const categories = getCategories();
  wrapper.innerHTML = categories.map((category) => (
    `<div class="slide-row__slide slide-row__slide_l swiper-slide">
      ${renderPreviewCard(category, { asLink: true, withTags: true })}
    </div>`
  )).join("");

  const swiperRoot = wrapper.closest(".swiper");
  if (swiperRoot?.swiper) {
    swiperRoot.swiper.update();
    swiperRoot.swiper.slideTo(0, 0);
  }
}

function hydrateHomeExamplePlaques() {
  if (!document.querySelector(".index-page")) return;
  const wrapper = document.querySelector("[data-example-slides]");
  const section = wrapper?.closest(".example-section");
  if (!wrapper) return;

  const items = getHomePlaques();
  if (!items.length) {
    if (section) section.hidden = true;
    wrapper.innerHTML = "";
    return;
  }

  if (section) section.hidden = false;
  wrapper.innerHTML = items.map(({ plaque, category }) => (
    `<div class="slide-row__slide slide-row__slide_xl swiper-slide">
      ${renderHomeExampleCard(plaque, category)}
    </div>`
  )).join("");
  updateExampleSwiper(wrapper);
}

function hydrateServicePlaques(category) {
  if (!document.querySelector(".service-details-page")) return;
  const wrapper = document.querySelector("[data-example-slides]");
  const section = wrapper?.closest(".example-section");
  if (!wrapper) return;

  const plaques = getServicesByCategory(category.key);
  if (!plaques.length) {
    if (section) section.hidden = true;
    wrapper.innerHTML = "";
    return;
  }

  if (section) section.hidden = false;
  wrapper.innerHTML = plaques.map((plaque) => `
    <div class="slide-row__slide slide-row__slide_xl swiper-slide">
      <button class="example-preview" type="button" data-service-plaque>
        <div class="example-preview__wrapper">
          <div class="example-preview__img">
            <picture>
              <img src="${escapeHtml(plaque.image)}" alt="${escapeHtml(plaque.name)}" width="280" height="280">
            </picture>
          </div>
          <div class="example-preview__content">
            <div class="example-preview__title h5">${escapeHtml(plaque.name)}</div>
          </div>
        </div>
      </button>
    </div>
  `).join("");

  const swiperRoot = wrapper.closest(".swiper");
  if (swiperRoot?.swiper) {
    swiperRoot.swiper.update();
    swiperRoot.swiper.slideTo(0, 0);
  }
}

function bindServicePlaques() {
  const wrapper = document.querySelector(".service-details-page [data-example-slides]");
  if (!wrapper || wrapper.dataset.bound === "true") return;
  wrapper.dataset.bound = "true";
  wrapper.addEventListener("click", (event) => {
    const plaque = event.target.closest("[data-service-plaque]");
    if (!plaque) return;
    event.preventDefault();
    if (typeof window.openPopup === "function") {
      window.openPopup("popup-feedback");
    }
  });
}

function hydrateServiceDetails() {
  const root = document.querySelector("[data-service-overview]");
  if (!root) return;

  const category = getCategoryFromLocation();
  const data = categoriesStore().getCategoriesData();
  if (!category) {
    const match = window.location.pathname.match(/^\/service\/([^/]+)\/?$/);
    if (match) window.location.replace("/error-page");
    return;
  }

  document.title = `Новая марка | ${category.title}`;

  const crumbCurrent = document.querySelector(".service-details-page .breadcrumbs__item:last-child [itemprop='name']");
  if (crumbCurrent) crumbCurrent.textContent = category.title;

  hydrateServicePlaques(category);
  bindServicePlaques();

  if (window.NMPortfolioContent?.renderServicePortfolio) {
    window.NMPortfolioContent.renderServicePortfolio(category);
  } else {
    window.setTimeout(() => {
      window.NMPortfolioContent?.renderServicePortfolio?.(category);
    }, 0);
  }

  const title = root.querySelector("[data-service-overview-title]");
  const lead = root.querySelector("[data-service-overview-lead]");
  const servicesTitle = root.querySelector("[data-service-overview-services-title]");
  const list = root.querySelector("[data-service-overview-list]");
  const img = root.querySelector("[data-service-overview-image]");
  const imgTitle = root.querySelector("[data-service-overview-image-title]");
  const nextLink = root.querySelector("[data-service-next-link]");
  const next = getNextCategory(category, data);

  if (title) title.innerHTML = category.titleHtml;
  if (lead) lead.textContent = category.subtitle;
  if (servicesTitle) servicesTitle.textContent = category.servicesTitle;

  if (img) {
    img.src = next?.overviewImage || categoriesStore().DEFAULT_OVERVIEW_IMAGE;
    img.alt = next?.title || category.title;
  }
  if (imgTitle) {
    imgTitle.textContent = next?.title || "";
  }
  if (nextLink) {
    if (next && next.id !== category.id) {
      nextLink.href = getServicePath(next);
      nextLink.removeAttribute("aria-disabled");
    } else {
      nextLink.removeAttribute("href");
      nextLink.setAttribute("aria-disabled", "true");
    }
  }

  if (list) {
    list.innerHTML = (category.points || []).map((point) => (
      `<li class="service-overview__item">${escapeHtml(point.name)}</li>`
    )).join("");
  }
}

function hydratePublicServices() {
  hydrateServicesPage();
  hydrateHomeServices();
  hydrateHomeExamplePlaques();
  hydrateServiceDetails();
}

document.addEventListener("nm:categories-updated", () => {
  hydratePublicServices();
});

document.addEventListener("nm:category-deleted", (event) => {
  const { deletedKey, fallbackKey } = event.detail || {};
  reassignServicesCategory(deletedKey, fallbackKey);
  hydratePublicServices();
});

window.NMServicesContent = {
  STORAGE_KEY,
  DEFAULT_PLAQUE_IMAGE,
  escapeHtml,
  createId,
  getServicePath,
  normalizeService,
  normalizePlaque: normalizeService,
  getDefaultData: () => ({ services: getDefaultServices() }),
  getServicesData,
  saveServicesData,
  getServices,
  getServicesByCategory,
  getHomeServices,
  getHomePlaques,
  getCategories,
  getCategoryBySlug,
  getCategoryFromLocation,
  getNextCategory,
  categoryWithServices,
  upsertService,
  deleteService,
  reassignServicesCategory,
  hydratePublicServices,
  hydrateServicesPage,
  hydrateHomeServices,
  hydrateServiceDetails,
  // legacy admin API shims
  buildTitleHtml: (...args) => categoriesStore().buildTitleHtml(...args),
  slugify: (...args) => categoriesStore().slugify(...args),
  uniqueSlug: (...args) => categoriesStore().uniqueSlug(...args),
  normalizePoint: (...args) => categoriesStore().normalizePoint(...args),
  normalizeCategory: (...args) => categoriesStore().normalizeCategory(...args),
  upsertCategory: (...args) => categoriesStore().upsertCategory(...args),
  deleteCategory: (...args) => categoriesStore().deleteCategory(...args),
  get DEFAULT_IMAGE() {
    return categoriesStore().DEFAULT_IMAGE;
  },
  get DEFAULT_OVERVIEW_IMAGE() {
    return categoriesStore().DEFAULT_OVERVIEW_IMAGE;
  },
};

window.NMApi?.ready?.then(hydratePublicServices);

